export const getWhatsAppTemplatesApi = async (axiosPrivate) => {
	const response = await axiosPrivate.get("/admin/broadcast/whatsapp/templates");
	return response.data;
};

export const saveWhatsAppTemplateConfigApi = async (axiosPrivate, payload) => {
	const response = await axiosPrivate.post("/admin/broadcast/whatsapp/template-config", payload);
	return response.data;
};

export const deleteWhatsAppTemplateConfigApi = async (axiosPrivate, templateName) => {
	const response = await axiosPrivate.delete(`/admin/broadcast/whatsapp/template-config/${encodeURIComponent(templateName)}`);
	return response.data;
};

export const sendWhatsAppBroadcastApi = async (axiosPrivate, payload) => {
	const response = await axiosPrivate.post("/admin/broadcast/whatsapp/send", payload);
	return response.data;
};

export const sendEmailBroadcastApi = async (axiosPrivate, payload) => {
	const response = await axiosPrivate.post("/admin/broadcast/email/send", payload);
	return response.data;
};

export const getBroadcastLogsApi = async (axiosPrivate, params = {}) => {
	const response = await axiosPrivate.get("/admin/broadcast/logs", {params});
	return response.data;
};
